export const getElementHeight = elementId => {
  return document.getElementById(elementId).offsetHeight;
};

export const getElementPosition = elementId => {
  return document.getElementById(elementId).getBoundingClientRect();
};
